export default __webpack_public_path__ + "static/media/Group 1406.a1f1af85.png";